/**
 * Mobile Table Fix
 * Automatically detects and makes tables responsive on mobile devices
 * Specifically targets tables with images on collection and page templates
 */

(function() {
  'use strict';
  
  // Run on page load and resize
  function initMobileTables() {
    if (window.innerWidth <= 768) {
      makeTablesResponsive();
    }
  }
  
  function makeTablesResponsive() {
    // Find all tables in the page content
    const tables = document.querySelectorAll('.page-content table, .collection-description table, .rte table');
    
    tables.forEach(function(table) {
      // Check if table has already been processed
      if (table.classList.contains('mobile-processed')) {
        return;
      }
      
      const firstRow = table.querySelector('tr');
      if (!firstRow) return;
      
      const cellCount = firstRow.querySelectorAll('td, th').length;
      const hasImages = table.querySelectorAll('img').length > 0;
      
      // Table with 5 columns and images (calibration target table)
      if (cellCount === 5 && hasImages) {
        table.classList.add('mobile-2col-grid');
        table.classList.add('mobile-processed');
      }
      // Table with 4+ columns (package specs table)
      else if (cellCount >= 4) {
        table.classList.add('mobile-responsive');
        table.classList.add('mobile-processed');
      }
      // Any table with images
      else if (hasImages && cellCount > 2) {
        table.classList.add('mobile-2col-grid');
        table.classList.add('mobile-processed');
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileTables);
  } else {
    initMobileTables();
  }
  
  // Re-initialize on window resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Remove existing classes to re-evaluate
      const processedTables = document.querySelectorAll('.mobile-processed');
      processedTables.forEach(function(table) {
        table.classList.remove('mobile-processed', 'mobile-2col-grid', 'mobile-responsive');
      });
      initMobileTables();
    }, 250);
  });
  
})();
